import { render, staticRenderFns } from "./sales-and-pricing.vue?vue&type=template&id=2f23636e"
import script from "./sales-and-pricing.vue?vue&type=script&lang=js"
export * from "./sales-and-pricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports